import {Component, EventEmitter, Injector, Input, OnInit, Output} from '@angular/core';
import {DialogBaseComponent} from "../../base-admin-panel/dialog-base/dialog-base.component";
import {GeozoneViewModel} from "../Model/GeozoneViewModel";
import {ZoneService} from "../../../../services/zones.service";
import {IManagableObject} from "../../IManagableObject";
import { ObjectsService } from "../../../../services/objects.service";
import {ObjectModel} from "../../../../models/ObjectModel";
import {IconViewModel} from "../../../../models/IconViewModel";

declare var g_Profile: any;

@Component({
    selector: 'app-geozone-edit',
    templateUrl: './geozone-edit.component.html',
    styleUrls: ['./geozone-edit.component.css'],
    standalone: false
})
export class GeozoneEditComponent extends DialogBaseComponent<GeozoneViewModel> implements OnInit {
  private zonesService: ZoneService;
  private copyOfModel: GeozoneViewModel;
  private interval = null;

  private objectsService: ObjectsService;
  public Objects: ObjectModel[] = [];
  public ObjectGroups: IManagableObject[] = [];

  @Input()
  public Icons: IconViewModel[] = [];

  @Input('model')
  set onModelSet(model: GeozoneViewModel) {
    this.model = model;
    this.useInReports = this.model.Flags.indexOf("NOUSEREPORT") < 0;
    this.events = this.model.Flags.replace("NOUSEREPORT", '').replace(" ", '');
  }

  constructor(protected injector: Injector) {
    super(injector);
    this.zonesService = injector.get(ZoneService);
    this.objectsService = injector.get(ObjectsService);
  }

  public groups: IManagableObject[] = [];

  @Output()
  public zoneChange: EventEmitter<string> = new EventEmitter<string>();

  ngOnInit() {
    this.zonesService.GetGroups()
      .subscribe(groups => {
        this.groups = groups;
      });
    this.objectsService.GetObjects()
      .subscribe(items => {
        this.Objects = items;
      });
    this.objectsService.GetObjectGroups()
      .subscribe(items => {
        this.ObjectGroups = items;
      });

    if (this.model.Id && this.model.Id > 0) {
      g_Profile.zones.Select(g_Profile.zones.GetObject(this.model.Id))
      /*this.zonesService.GetZoneGroups(this.model.Id)
        .subscribe(groups => {
          this.model.Groups = groups.map(g => g.Id);
        });*/
    }

    this.interval = setInterval(() => this.TestChanges(), 1000);
  }

  public events: string = "";
  public useInReports: boolean = false;

  @Output()
  public onClose: EventEmitter<any> = new EventEmitter<any>();
  public openedTabName: string = "Main";

  public onStrokeChanged(color) {
    this.model.Style.strokeColor = color;
  }

  public onFillChanged(color) {
    this.model.Style.fillColor = color;
  }


  private TestChanges()
  {
    if (!this.model.IsEqual(this.copyOfModel))
    {
      this.copyOfModel = this.model.Clone();
      this.zoneChange.emit();
    }
  }

  close()
  {
    this.model = new GeozoneViewModel();

    super.close();
    //this.onClose.emit();

    window.clearInterval(this.interval);
  }

  protected onEdit()
  {
    this.onCreated.emit();
    this.syncService.NotifyEntityChanged("Geozone", this.model.Id);
    super.submit();
    this.close();
  }

  submit() {
    this.model.Flags = this.events;
    this.model.Flags += this.useInReports ? "" : " NOUSEREPORT";
    if (this.model.IconId == 0)
      this.model.IconId = undefined;

    if (this.model.IconId == undefined && this.model.Style.type == 'point') {
      this.toastr.error(this.translate.instant("Icon is required"));
      return;
    }
    this.model.GroupIds = this.model.Groups;

    if (this.model.Id == 0) {
      this.zonesService.CreateZone(this.model)
        .subscribe((res) => {
          this.zonesService.SetObjects(res['id'], this.model.Objects);
          this.onEdit();
        });
    }
    else {
      this.zonesService.EditZone(this.model)
        .subscribe((res) => {
          this.zonesService.SetObjects(this.model.Id, this.model.Objects);
          this.onEdit();
        });
    }
  }

  public openTab(tabName: string) {
    this.openedTabName = tabName;
  }
  public redraw()
  {
    this.model.Points = "";
    this.zoneChange.emit();
  }
}
